<!--
This component generates the pass detail view.
Receiver must pass a String and Object to {passDetail} to let the component generate the proper ui.
-->
<template>
  <div>
    <div class="row float-right">
      <div class="col-md">
        <button @click="onClickEdit()"><i class="fas fa-edit"></i></button>
      </div>
      <div class="col-md">
        <button @click="onClickDeactivate()"><i class="fas fa-ban"></i></button>
      </div>
    </div>
    <!-- Type of Pass -->
    <section class="pass-detail-body">
      <ul class="pass-detail-content">
        <li class="pass-detail-content-title"></li>
        <li class="pass-detail-content-value"></li>

        <li class="pass-detail-content-title">Name</li>
        <li class="pass-detail-content-value">{{ passDetail.pass_name }}</li>

        <li class="pass-detail-content-title">Type</li>
        <li class="pass-detail-content-value">{{ passDetail.type_of_pass }}</li>

        <li class="pass-detail-content-title">Date & Time</li>
        <li class="pass-detail-content-value">
          Start: {{ passDetail.visiting_date }} {{ passDetail.visiting_time }}
        </li>
        <li class="pass-detail-content-value">
          End: {{ passDetail.validity_date }} {{ passDetail.validity_time }}
        </li>
        <li class="pass-detail-content-value" v-if="passDetail.disposal_date === '1 months'">
          Disposal: 1 month
        </li>
        <li class="pass-detail-content-value" v-else-if="passDetail.disposal_date === '1 years'">
          Disposal: 1 year
        </li>
        <li class="pass-detail-content-value" v-else>
          Disposal: {{ passDetail.disposal_date }}
        </li>
      </ul>

      <hr>

      <ul class="pass-detail-content">
        <li class="pass-detail-content-title">Contact person</li>
        <li class="pass-detail-content-value">{{ passDetail.contact_person }}</li>

        <li class="pass-detail-content-title">Reason for visit</li>
        <li class="pass-detail-content-value">{{ passDetail.reason_for_visit }}</li>

        <li class="pass-detail-content-title">Contact email</li>
        <li class="pass-detail-content-value">{{ passDetail.company_email }}</li>

        <li class="pass-detail-content-title">Allow unverified user</li>
        <li class="pass-detail-content-value" v-if="!passDetail.verify_identity">Yes</li>
        <li class="pass-detail-content-value" v-else>No</li>
      </ul>

      <div v-if="passDetail.request_access" class="pass-detail-section">
        <p>Request Access Information</p>
      </div>

      <ul class="pass-detail-content">
        <li class="pass-detail-content-title">Request Allowed</li>
        <li class="pass-detail-content-value" v-if="passDetail.request_access">Yes</li>
        <li class="pass-detail-content-value" v-else>No</li>

        <li class="pass-detail-content-title">Needs Approval</li>
        <li class="pass-detail-content-value" v-if="passDetail.request_needs_approval">Yes</li>
        <li class="pass-detail-content-value" v-else>No</li>

        <li class="pass-detail-content-title">Pass introduction</li>
        <li class="pass-detail-content-value pass-intro">{{ passDetail.pass_intro }}</li>

        <li class="pass-detail-content-title">Form questions:</li>
        <li class="pass-detail-content-value"
          v-for="(item, index) in passDetail.pass_access_questions" :key="index">
          {{ item.question }}
        </li>
      </ul>

      <div v-if="passDetail.request_access" class="pass-detail-section">
        <p>Building Information</p>
      </div>

      <ul class="pass-detail-content">
        <li class="pass-detail-content-title">Building Name</li>
        <li class="pass-detail-content-value">{{ passDetail.building_name }}</li>

        <li class="pass-detail-content-title">Address</li>
        <li class="pass-detail-content-value">{{ passDetail.building_address }}</li>

        <li class="pass-detail-content-title">Floor and Unit Number</li>
        <li class="pass-detail-content-value">{{ passDetail.floor_number }}</li>
      </ul>

      <div class="pass-detail-section">
        <p>Data Privacy and Agreements</p>
      </div>

      <ul class="pass-detail-content">
        <li class="pass-detail-content-title">Reason for collection</li>
        <li class="pass-detail-content-value">{{ passDetail.reason_for_collecting }}</li>

        <li class="pass-detail-content-title">Requested access to details</li>
        <li class="pass-detail-content-value"
          v-for="detail in passDetail.included_pass_details" :key="detail">
          {{ detail }}
        </li>

        <li class="pass-detail-content-title">Policies and Agreements</li>
        <li class="pass-detail-content-value" v-for="d in passDetail.agreements_data" :key="d.id">
          <a :href="d.link" v-if="d.other_agreement_name !== 'none'">
            {{d.other_agreement_name}}
          </a>
          <a :href="d.link" v-else>{{d.agreement_name}}</a>
        </li>
      </ul>

      <div class="pass-detail-section">
        <p>Settings</p>
      </div>

      <ul class="pass-detail-content">
        <li class="pass-detail-content-value" @click="onClickDeactivate">Deactivate</li>
      </ul>
    </section>
  </div>
</template>

<style scoped>

section {
  margin-bottom: 60px;
}

.pass-detail-body {
  background-color: #fff;
  padding-bottom: 30px;
}

/deep/.pass-detail-section h3 {
  font-size: 28px;
  margin-bottom: 20px;
}

/deep/ span {
  font-weight: 800;
}

/deep/ ul {
  margin: 4px 0px 2px 40px;
  padding: 0px;
}

/deep/ .pass-detail-content {
  padding-top: 20px;
  list-style-type: none;
}

/deep/ .pass-detail-content li {
  padding-bottom: 10px;
}

/deep/ .pass-detail-content-title {
  font-size: 12px;
  color: #6c757d;
  font-weight: bold;
}

/deep/ .pass-detail-content-value {
  font-size: 15px;
  margin-bottom: 10px;
  font-weight: bold;
}

.pass-detail-section {
  background-color: #FAFAFA;
}

.pass-detail-section p {
  padding-top: 30px;
  padding-left: 25px;
  padding-bottom: 30px;
  font-weight: bold;
  color: #6c757d;
}

.pass-intro {
  white-space: pre-line;
  width: 85%;
}

</style>

<script>
export default {
  props: {
    isOrganizer: String,
    passDetail: Object,
    userDetailCategories: Array,
    agreementCategories: Array,
    onClickEdit: Function,
    onClickDeactivate: Function
  },
}
</script>



// WEBPACK FOOTER //
// src/components/passes/PassViewDetail.vue